import { configureStore } from '@reduxjs/toolkit'
import authSlice from '../Reducers/authSlice'
import snackbarSlice from '../Reducers/snackbarSlice'
import onboardingSlice from '../Reducers/onboardingSlice'

export const store = configureStore({
    reducer: {
        auth: authSlice,
        snackbar: snackbarSlice,
        onboarding: onboardingSlice
    },
})
